var map = {
	"./frontpage_00001.jpg": 162,
	"./frontpage_00002.jpg": 163,
	"./frontpage_00003.jpg": 164,
	"./frontpage_00004.jpg": 165,
	"./frontpage_00005.jpg": 166,
	"./frontpage_00006.jpg": 167,
	"./frontpage_00007.jpg": 168,
	"./frontpage_00008.jpg": 169,
	"./frontpage_00009.jpg": 170,
	"./frontpage_00010.jpg": 171,
	"./frontpage_00011.jpg": 172,
	"./frontpage_00012.jpg": 173,
	"./frontpage_00013.jpg": 174,
	"./frontpage_00014.jpg": 175,
	"./frontpage_00015.jpg": 176,
	"./frontpage_00016.jpg": 177,
	"./frontpage_00017.jpg": 178
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;


//////////////////
// WEBPACK FOOTER
// ./src/core/images/frontpage \.jpg$
// module id = 161
// module chunks = 0